





























































import { IDateItem, IFilterItem } from '@app/componentlib/common/types/JobSearchTypes'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import Vue from 'vue'
import Component from 'vue-class-component'
import SearchFilterDropdownMobile from './SearchFilterDropdownMobile.vue'
import SearchFilterMobileButton from './SearchFilterMobileButton.vue'

@Component<SearchFiltersMobile>({
  components: {
    SearchFilterDropdownMobile,
    SearchFilterMobileButton
  },
  props: {
    activeChosenFilter: String,
    startDate: Object,
    dates: Array,
    jobCategories: Array,
    careers: Array,
    industries: Array,
    chosenJobCategories: Array,
    chosenCareers: Array,
    chosenIndustries: Array,
    activeFilter: Array,
    filtersToExclude: Array
  }
})

export default class SearchFiltersMobile extends Vue {
  /**
   * Props variables
   */
  activeChosenFilter: string | undefined
  startDate: IDateItem | undefined
  dates: IDateItem[] | undefined
  jobCategories: IFilterItem[] | undefined
  careers: IFilterItem[] | undefined
  industries: IFilterItem[] | undefined
  chosenJobCategories: string[] | undefined
  chosenCareers: string[] | undefined
  chosenIndustries: string[] | undefined
  activeFilter: IFilterItem[] | undefined
  filtersToExclude: String[] = []

  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */


  /**
   * Getters
   */
  get t (): any {
    return AppModule.translations
  }

  get isMobile (): boolean {
    return AppModule.isMobile
  }

  /**
   * Methods
   */
  changeActiveFilter(item: any, chosenFilter: string) {
    this.$emit('changeActiveFilter', {item: item, chosenFilter: chosenFilter})
    this.changeMobileFiltersIsOpen(true)
  }

  dateClicked(item: IDateItem) {
    this.$emit('dateClicked', item)
  }

  changeShowOverlay(e: any) {
    this.$emit('changeShowOverlay', e.type === "show" ? true : false)
  }

  changeMobileFiltersIsOpen(bool: boolean) {
    this.$emit('changeMobileFiltersIsOpen', bool)
  }

  clickedItemFilter(arrayToPushTo: string, item: string) {
    this.$emit('clickedItemFilter', {arrayToPushTo: arrayToPushTo, item: item})
  }

  startSearch() {
    this.$emit('startSearch')
  }
}
